import lodash from "lodash";
import { createColumnInlineInputNumber, createColumnInlineSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../../../../utils/page";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/hazDiscussAquatic";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const callHazAquaticType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_AQUATIC_TYPE", value: searchQuery });
export const callHazSubAquaticType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_AQUATIC_TYPE", value: searchQuery });
export const callDurationUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DURATION_UNIT", value: searchQuery });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazDiscussAquatic.refAquaticType"),
            dataIndex: "refAquaticType",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazAquaticType, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazAquaticType,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            record.refAquaticType = value;
                            record.refSubAquaticType = null;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazDiscussAquatic.refSubAquaticType"),
            dataIndex: "refSubAquaticType",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazSubAquaticType, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly || !record.refAquaticType,
                        list: ({ searchQuery }) =>
                            callHazSubAquaticType({ searchQuery }).then(items =>
                                items.filter(item => item.refParent.id === record.refAquaticType?.id)
                            ),
                        optLabel: "value",
                        "onUpdate:value": value => (record.refSubAquaticType = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.hazDiscussAquatic.qty"),
            dataIndex: "qty",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ key }) =>
                lodash.merge(
                    { disabled: viewOnly, allowPrecision: true, addonAfter: () => <div>mg/l</div> },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.hazDiscussAquatic.duration"),
            dataIndex: "duration",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ comma: false }),
            customRenderInputProp: ({ key }) =>
                lodash.merge(
                    { disabled: viewOnly, comma: false },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.hazDiscussAquatic.refDurationUnit"),
            dataIndex: "refDurationUnit",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callDurationUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callDurationUnit,
                        optLabel: "value",
                        "onUpdate:value": value => (record.refDurationUnit = value)
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                )
        })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({}) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
